/**
 * /QuadPoints - cho nhom chu thich DANH DAU VAN BAN.
 *
 * Con lai ba loai dung khoa nay: gach chan, gach ngang, gach luon song. To sang
 * DA BI GO BO theo yeu cau cua nguoi dung, va cung voi no la ham
 * highlightRectsForRuns() (gom run thanh tung dong de om sat chu) - ham do chi
 * ton tai vi to sang, khong ai khac goi. Xem git de doc lai neu can.
 *
 * THU TU LA CHO DE SAI. Dac ta PDF (bang 179) mo ta bon diem theo chieu nguoc
 * kim dong ho bat dau tu goc duoi-trai, NHUNG Acrobat luon ghi va luon doc theo
 * thu tu tren-trai, tren-phai, duoi-trai, duoi-phai. Vi Acrobat la ban trien
 * khai tham chieu tren thuc te, moi trinh xem khac deu theo no. Ghi theo dac ta
 * cho ra mot dau danh lat cheo hoac bien mat trong nhieu trinh xem.
 */
import type { PdfRect } from '@pdfeditor/types';

export function quadPointsOf(rect: PdfRect): number[] {
  const x0 = rect.x;
  const y0 = rect.y;
  const x1 = rect.x + rect.width;
  const y1 = rect.y + rect.height;
  return [x0, y1, x1, y1, x0, y0, x1, y0];
}
